import { CUSTOM_WIDGET_TYPES } from 'reporting-data/tsTypes/customWidgetTypes';

/**
 * Gate to control custom widget migration.
 * Create a new gate using the gating manager and set this constant to the gate name
 */
export const CUSTOM_WIDGET_MIGRATION_GATE = '';

/**
 * Custom widgets that are currently in migrations.  Uses CUSTOM_WIDGET_MIGRATION_GATE to control the migration
 */
export const CUSTOM_WIDGET_IN_MIGRATIONS = [];

/**
 * Custom widgets that have been migrated to reporting-plugins and awaiting a Report Migration
 */
export const CUSTOM_WIDGET_MIGRATED = [CUSTOM_WIDGET_TYPES.ENGAGEMENT_STREAM];